export const MOVE_COST_CENTRE_ERROR_MESSAGES = {
  cost_centre_not_valid:
    'El centro de costos elegido no puede ser el mismo centro de costos',
  account_not_visible: 'No tienes permisos sobre las cuentas',
  child_account_with_balance_found:
    'No se puede realizar la acción porque existen centros de costos o tarjetas que dependen del centro de costo que usted esta intentando mover que tienen saldo. Transfiera su saldo a otra cuenta antes de continuar',
  account_with_balance:
    'No se puede realizar la acción porque el centro de costo que usted esta intentando mover tiene saldo. Transfiera su saldo a otra cuenta antes de continuar',
  default: 'Hubo un error al intentar mover el centro de costos',
};
